module.exports = __webpack_public_path__ + "img/yano_Q_400_15_6.63a12d8b.png";